import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { ApiError } from 'src/types/interfaces/api-error';

import { hostsApi } from '../../api/lib/hosts';
import { discountTemplatesKeys } from '../../api/query-keys/discount-templates';

import { hostsKeys } from '@/features/hosts/api/query-keys/hosts';

export const useUpdateHostDiscountTemplate = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ hostId, discountTemplates }: { hostId: number; discountTemplates: number[] }) =>
      hostsApi.updateHostDiscountTemplates(hostId, discountTemplates),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: hostsKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: discountTemplatesKeys.all,
      });
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
